import { render, staticRenderFns } from "./PkgRiskItemForm.vue?vue&type=template&id=0509d392&"
import script from "./PkgRiskItemForm.vue?vue&type=script&lang=js&"
export * from "./PkgRiskItemForm.vue?vue&type=script&lang=js&"
import style0 from "./PkgRiskItemForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PkgRiskItemForm.vue"
export default component.exports